import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.4rem;
  max-width: 1250px;
`

export const Title = styled.h3`
  align-self: flex-start;
  margin-left: 15px;
`
